// This error code indicates that
export enum ChainCodeErrorEnum {
  UNAVAILABLE = 4902, // chain has not been added to MetaMask
  CANCELLED = 4001, // switching chain has been cancelled
  DENIED = -32603, // user denied
}
